import { getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions();

// User Portal Functions
export const exportUserData = async (): Promise<{
  exportId: string;
  recordCount: number;
}> => {
  const callable = httpsCallable(functions, 'exportUserData');
  
  try {
    const result = await callable({});
    return result.data as { exportId: string; recordCount: number };
  } catch (error) {
    console.error('Error calling exportUserData:', error);
    throw error;
  }
};

export const getUserStats = async (): Promise<{
  totalSubmissions: number;
  approvedSubmissions: number;
  rejectedSubmissions: number;
  pendingSubmissions: number;
  totalRewardEarned: number;
}> => {
  const callable = httpsCallable(functions, 'getUserStats');
  
  try {
    const result = await callable({});
    return result.data as {
      totalSubmissions: number;
      approvedSubmissions: number;
      rejectedSubmissions: number;
      pendingSubmissions: number;
      totalRewardEarned: number;
    };
  } catch (error) {
    console.error('Error calling getUserStats:', error);
    throw error;
  }
};

export const deleteUserAccount = async (): Promise<{
  success: boolean;
}> => {
  const callable = httpsCallable(functions, 'deleteUserAccount');
  
  try {
    const result = await callable({});
    return result.data as { success: boolean };
  } catch (error) {
    console.error('Error calling deleteUserAccount:', error);
    throw error;
  }
};

export const createDownloadPackage = async (submissionIds: string[]): Promise<{
  downloadUrl: string;
  totalLabels: number;
  totalPrice: number;
  exportId: string;
}> => {
  const callable = httpsCallable(functions, 'createDownloadPackage');
  
  try {
    const result = await callable({ submissionIds });
    return result.data as {
      downloadUrl: string;
      totalLabels: number;
      totalPrice: number;
      exportId: string;
    };
  } catch (error) {
    console.error('Error calling createDownloadPackage:', error);
    throw error;
  }
};



